import { Button } from '@carbon/react';
import type { MineralType } from 'types/minerals';
import styles from './tc-dca-configuration-panel.module.scss';

const STREAM_LABELS: Record<MineralType, string> = {
  oil: 'Oil',
  gas: 'Gas',
  water: 'Water',
};

interface TcDcaFitButtonProps {
  stream: MineralType;
  isLoading: boolean;
  disabled: boolean;
  onFit: () => void;
}

export const TcDcaFitButton = ({
  stream,
  isLoading,
  disabled,
  onFit,
}: TcDcaFitButtonProps) => {
  return (
    <div className={styles.fitButtonWrapper}>
      <span className={styles.fitStreamLabel}>
        Stream: {STREAM_LABELS[stream]}
      </span>
      <Button
        size="sm"
        kind="primary"
        disabled={disabled || isLoading}
        onClick={onFit}
      >
        {isLoading ? 'Fitting...' : 'Fit'}
      </Button>
    </div>
  );
};
